var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('div',{staticClass:"container"},[_c('snowflake-side-menu'),_c('div',{staticClass:"page"},[_c('el-header',[_c('snowflake-header',{attrs:{"title":_vm.headerTitle}})],1),_c('el-main',[_c('router-view',{staticClass:"content"})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }